import React from "react";
import { useUserContext } from "context/UserContext";
import CouponManagementBK from "layouts/BK/couponManagement";
import { isBkLikeRole } from "utils/roleUtils";

function CouponManagement() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <CouponManagementBK />;
  }
  return null;
}

export default CouponManagement;
